import type { FontFamily } from '@burfy/docs-core';

/**
 * The families that ship with the app.
 *
 * The Indic families matter more than the Latin ones here: a document typed in
 * Malayalam is unreadable in a font that has no Malayalam glyphs, and the
 * browser's fallback for a missing script is a row of empty boxes. Every
 * language the IME offers has a family that can actually render it.
 *
 * `@font-face` declarations do not download anything until a glyph needs them,
 * so listing these costs nothing until one is used.
 */
export const BUNDLED_FONTS: readonly FontFamily[] = [
  { family: 'Inter', label: 'Inter', source: 'bundled' },
  { family: 'Lora', label: 'Lora (serif)', source: 'bundled' },
  { family: 'JetBrains Mono', label: 'JetBrains Mono', source: 'bundled' },

  {
    family: 'Anek Malayalam',
    label: 'Anek Malayalam · മലയാളം',
    language: 'ml',
    source: 'bundled',
  },
  {
    family: 'Anek Devanagari',
    label: 'Anek Devanagari · हिन्दी',
    language: 'hi',
    source: 'bundled',
  },
  {
    family: 'Anek Tamil',
    label: 'Anek Tamil · தமிழ்',
    language: 'ta',
    source: 'bundled',
  },
  {
    family: 'Anek Telugu',
    label: 'Anek Telugu · తెలుగు',
    language: 'te',
    source: 'bundled',
  },
  {
    family: 'Anek Kannada',
    label: 'Anek Kannada · ಕನ್ನಡ',
    language: 'kn',
    source: 'bundled',
  },
  {
    family: 'Noto Sans Arabic',
    label: 'Noto Sans Arabic · العربية',
    language: 'ar',
    source: 'bundled',
  },
];
